import { createBrowserHistory } from "history";
// import { BASE_ROUTE } from '../config/constants'

export const history = createBrowserHistory();
